import { useState } from 'react';
import backgroundImage from "../../assets/images/ReiNew.jpeg";
import axios from 'axios';
import Captcha from '../../component/Captcha';




export default function REIExpoForm() {
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        city: '',
        category: 'developer',
        mwpRequired: '',
        initialInvestment: '',
        minimumPurchase: '',
        companyName: '',
        supplierType: '',
        // resume: null,
        remark: '',
        role: '',
        file: null,
        dealerInvest:''
        // supplierCatalogue:null
    });

    const [captchaValue, setCaptchaValue] = useState('');
    const [resetCaptcha, setResetCaptcha] = useState(false);
    const [captchaInput, setCaptchaInput] = useState('');
    const [loading, setLoading] = useState(false);




    const handleCaptchaChange = (value) => {
        setCaptchaInput(value);
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (captchaInput === captchaValue) {
            setLoading(true);
            alert('CAPTCHA Verified!');

            let Formdata = new FormData();
            Formdata.append('name', formData.name)
            Formdata.append('mobile', formData.mobile)
            Formdata.append('mwp', formData.mwpRequired)
            Formdata.append('category', formData.category)
            Formdata.append('initialInvestment', formData.initialInvestment)
            Formdata.append('minimumPurchase', formData.minimumPurchase)
            Formdata.append('remark', formData.remark)
            Formdata.append('city', formData.city)
            Formdata.append('supplierType', formData.supplierType)
            Formdata.append('role', formData.role)
            Formdata.append('companyName', formData.companyName)
            Formdata.append('file', formData.file)
            Formdata.append('dealerInvest', formData.dealerInvest)

            try {

                let res = await axios.post('https://gautamsolar.us/submit-rei-form', Formdata);
                if (res?.data?.success) {
                    alert(res?.data?.message);
                    setLoading(false);
                    window.location.reload();
                }
            } catch (er) {
                console.log(er)
                window.location.reload();
            }

        }

        else {
            alert('CAPTCHA Verification Failed! Please try again.');
        }
    };



    const renderCategoryFields = () => {
        switch (formData.category) {
            case 'developer':
                return (
                    <div style={styles.fieldGroup}>
                        <label style={styles.label}>How Many MWp Required?*</label>
                        <select
                            style={styles.input}
                            name="mwpRequired"
                            value={formData.mwpRequired}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select MWp Range</option>
                            <option value="more-than-500MWp">More than 500 MWp</option>
                            <option value="100MWp-500MWp">100 MWp to 500 MWp</option>
                            <option value="10MWp-100MWp">10 MWp to 100 MWp</option>
                            <option value="1MWp-10MWp">1 MWp to 10 MWp</option>
                            <option value="less-than-1MWp">Less than 1 MWp</option>
                            <option value="something-else">I want Something else</option>
                        </select>
                    </div>
                );

            case 'epc':

                return (
                    <div style={styles.fieldGroup}>
                        <label style={styles.label}>How Many MWp Required?*</label>
                        <select
                            style={styles.input}
                            name="mwpRequired"
                            value={formData.mwpRequired}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select MWp Range</option>
                            <option value="more-than-500MWp">More than 500 MWp</option>
                            <option value="100MWp-500MWp">100 MWp to 500 MWp</option>
                            <option value="10MWp-100MWp">10 MWp to 100 MWp</option>
                            <option value="1MWp-10MWp">1 MWp to 10 MWp</option>
                            <option value="less-than-1MWp">Less than 1 MWp</option>
                            <option value="something-else">I want Something else</option>
                        </select>
                    </div>
                );

            case 'dealer':
                return (
                    <>
                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>When do you want to Invest?*</label>
                            <select onChange={handleChange} style={styles.input} name="dealerInvest" required>
                                <option value="" disabled selected>Select an option</option>
                                <option value="within 15 days">Within 15 days</option>
                                <option value="15 to 30 days">15 to 30 days</option>
                                <option value="after 30 days">After 30 days</option>
                                <option value="exploring/need more information">Just Exploring / Need more Information</option>
                            </select>
                        </div>
                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>Please specify the initial monthly investment (in ₹ lacs) you plan to allocate for becoming a distributor?*</label>
                            <input
                                type="text"
                                style={styles.input}
                                name="initialInvestment"
                                value={formData.initialInvestment}
                                onChange={handleChange}
                                required
                                placeholder="Enter investment amount in lacs"
                            />
                        </div>
                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>Please specify the minimum value of products (in ₹ lacs) you commit to purchase from the company on a monthly basis?*</label>
                            <input
                                type="text"
                                style={styles.input}
                                name="minimumPurchase"
                                value={formData.minimumPurchase}
                                onChange={handleChange}
                                required
                                placeholder="Enter minimum purchase value in lacs"
                            />
                        </div>
                    </>
                );

            case 'other':
                return null;

            default:
                return null;
        }
    };

    const styles = {
        container: {
            minHeight: '100vh',
            background: '#f5f5f5',
            padding: '20px',
            boxSizing: 'border-box'
        },
        card: {
            maxWidth: '1200px',
            margin: '0 auto',
            background: 'white',
            borderRadius: '20px',
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
        },
        imageSection: {
            // background: '#a20000',
            padding: '10px',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '300px',
            className: 'image-section'
        },
        imageContent: {
            width: '100%',
            // maxWidth: '800px',
            position: 'relative',
            zIndex: 2
        },
        expoImage: {
            width: '100%',
            height: 'auto',
            borderRadius: '10px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
            display: 'block'
        },
        formSection: {
            padding: '40px 30px',
            background: 'white',
            className: 'form-section'
        },
        formTitle: {
            fontSize: '2em',
            fontWeight: '600',
            marginBottom: '30px',
            color: '#333',
            textAlign: 'center',
            lineHeight: '1.2'
        },
        fieldGroup: {
            marginBottom: '20px'
        },
        fieldRow: {
            // display: 'grid',
            // gridTemplateColumns: '1fr 1fr',
            // gap: '20px',
            // marginBottom: '20px'
            lineHeight: '1.5'
        },

        label: {
            fontWeight: '600',
            color: '#555',
            marginBottom: '8px',
            display: 'block',
            fontSize: '0.95em'
        },
        input: {
            width: '100%',
            borderRadius: '10px',
            border: '2px solid #e0e0e0',
            padding: '12px 16px',
            fontSize: '1em',
            transition: 'all 0.3s',
            boxSizing: 'border-box',
            fontFamily: 'inherit'
        },
        radioGroup: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '15px'
        },
        radioLabel: (isSelected) => ({
            display: 'flex',
            alignItems: 'center',
            padding: '12px 20px',
            border: '2px solid',
            borderColor: isSelected ? '#a20000' : '#e0e0e0',
            background: isSelected ? '#ffe5e5' : 'white',
            borderRadius: '10px',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontSize: '0.95em',
            className: 'radio-label'
        }),
        submitBtn: {
            background: '#a20000',
            border: 'none',
            borderRadius: '10px',
            padding: '15px 40px',
            fontSize: '1.1em',
            fontWeight: '600',
            color: 'white',
            // width: '100%',
            transition: 'all 0.3s',
            boxShadow: '0 4px 15px rgba(162, 0, 0, 0.4)',
            cursor: 'pointer'
        },
        circle1: {
            position: 'absolute',
            width: '300px',
            height: '300px',
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '50%',
            top: '-100px',
            right: '-100px',
            zIndex: 1
        },
        circle2: {
            position: 'absolute',
            width: '200px',
            height: '200px',
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '50%',
            bottom: '-50px',
            left: '-50px',
            zIndex: 1
        },
        heading: {
            textAlign: 'center',
            marginBottom: '30px',
            padding: '0 20px'
        },
        mainHeading: {
            fontSize: '2.5em',
            fontWeight: '700',
            color: '#a20000',
            marginBottom: '10px',
            textTransform: 'uppercase',
            letterSpacing: '1px'
        },
        boothInfo: {
            fontSize: '1.3em',
            fontWeight: '600',
            color: '#333',
            margin: '0'
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.heading}>
                <h1 style={styles.mainHeading}>Visit Gautam Solar</h1>
                <p style={styles.boothInfo} className="booth-info">Booth No. R312, Hall No. 11</p>
            </div>

            <div style={styles.card}>
                {/* Image Section */}
                <div style={styles.imageSection} className="image-section">
                    <div style={styles.circle1}></div>
                    <div style={styles.circle2}></div>
                    <div style={styles.imageContent}>
                        <img
                            src={backgroundImage}
                            alt="Gautam Solar REI Expo 2025"
                            style={styles.expoImage}
                        />
                    </div>
                </div>

                {/* Form Section */}
                <div style={styles.formSection} className="form-section">
                    <h2 style={styles.formTitle}>Registration Form</h2>

                    <form onSubmit={handleSubmit}>
                        <div style={styles.fieldRow}>
                            <div style={{ marginBottom: '10px' }}>
                                <label style={styles.label}>Name*</label>
                                <input
                                    type="text"
                                    style={styles.input}
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    placeholder="Enter your name"
                                />
                            </div>
                            <div style={{ marginBottom: '10px' }}>
                                <label style={styles.label}>Mobile / Whatsapp No*</label>
                                <input
                                    type="tel"
                                    style={styles.input}
                                    name="mobile"
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    required
                                    placeholder="Enter mobile number"
                                />
                            </div>
                        </div>

                        <div style={styles.fieldRow}>
                            <div style={{ marginBottom: '10px' }}>
                                <label style={styles.label}>City*</label>
                                <input
                                    type="text"
                                    style={styles.input}
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    required
                                    placeholder="Enter city"
                                />
                            </div>
                        </div>

                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>Category*</label>
                            <div style={styles.radioGroup}>
                                {['developer', 'epc', 'dealer', 'other'].map((cat) => (
                                    <label
                                        key={cat}
                                        className="radio-label"
                                        style={styles.radioLabel(formData.category === cat)}
                                    >
                                        <input
                                            type="radio"
                                            name="category"
                                            value={cat}
                                            checked={formData.category === cat}
                                            onChange={handleChange}
                                            required
                                            style={{ marginRight: '8px' }}
                                        />
                                        {cat === 'developer' ? 'Developer' :
                                            cat === 'epc' ? 'EPC/System Integrator' :
                                                cat === 'dealer' ? 'Dealer/Distributor' :
                                                    'Others(Supplier/JobSeeker/Misc)'}
                                    </label>
                                ))}
                            </div>
                        </div>

                        {renderCategoryFields()}

                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>Remark</label>
                            <textarea
                                style={{ ...styles.input, minHeight: '100px', resize: 'vertical' }}
                                name="remark"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter your remarks or additional information"
                            />
                        </div>


                        <div className="text-center mt-4 p-1 border-top">
                            <Captcha
                                captchaValue={captchaValue}
                                setCaptchaValue={setCaptchaValue}
                                handleCaptchaChange={handleCaptchaChange}
                                resetCaptcha={resetCaptcha}
                                setResetCaptcha={setResetCaptcha}
                            />

                            <button
                                disabled={loading === true}
                                type="submit"
                                style={styles.submitBtn}
                                onMouseOver={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.background = '#8a0000';
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.background = '#a20000';
                                }}
                            >
                                {loading ?
                                    <div className="spinner-border text-white" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    :
                                    'Submit Registration'
                                }

                            </button>
                        </div>

                    </form>
                </div>
            </div>

            <style>{`
        @media (max-width: 768px) {
          h2 {
            font-size: 1.5em !important;
          }
        }
        @media (max-width: 600px) {
          h1 {
            font-size: 1.8em !important;
          }
        }
        @media (max-width: 480px) {
          /* Main heading */
          h1 {
            font-size: 1.5em !important;
          }
          
          /* Form title */
          h2 {
            font-size: 1.3em !important;
            margin-bottom: 20px !important;
          }
          
          /* Labels */
          label {
            font-size: 0.85em !important;
          }
          
          /* Inputs */
          input, select, textarea {
            font-size: 0.9em !important;
            padding: 10px 12px !important;
          }
          
          /* Radio labels */
          .radio-label {
            font-size: 0.85em !important;
            padding: 10px 15px !important;
          }
          
          /* Submit button */
          button {
            font-size: 1em !important;
            padding: 12px 30px !important;
          }
          
          /* Form section padding */
          .form-section {
            padding: 30px 20px !important;
          }
          
          /* Image section */
          .image-section {
            padding: 30px 20px !important;
          }
          
          /* Booth info */
          .booth-info {
            font-size: 1.1em !important;
          }
        }
              `}</style>
        </div>
    );
}